import { ResourcesConfig } from 'aws-amplify';

const VITE_HOST = import.meta.env.VITE_HOST;
const MODE = import.meta.env.MODE;

const host = MODE.includes('dev') ? 'https://admin.local.aktify.io:3000' : VITE_HOST;

const config = (): ResourcesConfig =>
  localStorage.getItem('amplifyClientId')
    ? {
        Auth: {
          // REQUIRED - Amazon Cognito Region
          Cognito: {
            loginWith: {
              email: true,
              oauth: {
                domain: localStorage.getItem('amplifyCognitoHostedDomain') || '',
                scopes: ['phone', 'email', 'profile', 'openid'],
                redirectSignIn: [`${host}/login/callback`],
                redirectSignOut: [`${host}`],
                responseType: 'code',
              },
            },
            userPoolClientId: localStorage.getItem('amplifyClientId') || '',
            userPoolId: localStorage.getItem('amplifyUserPoolId') || '',
            identityPoolId: '',
          },
        },
      }
    : {};

export default config;
